<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-row>
      <b-col>
        <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
          <label>Fecha inicio:<validacion/></label>
          <b-input-group size="sm" class="mb-2">
            <b-form-datepicker placeholder="Fecha inicio"
                               :max="new Date()"
                               @input="fechaMaxima($event)"
            ></b-form-datepicker>
          </b-input-group>
          <b-form-invalid-feedback :state="filtro.fechaInicio != null">
            Este campo es obligatorio
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
      <b-col>
        <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext" v-if="filtro.fechaInicio !== null">
          <label>Fecha fin:<validacion/></label>
          <b-input-group size="sm" class="mb-2">
            <b-form-datepicker placeholder="Fecha fin"
                               v-model="filtro.fechaFin"
                               :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                               :min="filtro.fechaInicio"
                               @input="listarTraspasos"
            ></b-form-datepicker>
          </b-input-group>
          <b-form-invalid-feedback :state="filtro.fechaFin != null">
            Este campo es obligatorio
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
    </b-row>
    <TablaEsteroides
        :items.sync="listMovimientos"
        :fields.sync="movimientoService.fieldsTraspasoPorEstatus"
        :clinicas="listClinicas"
        @paginaActualHijo="paginaActualPadre = $event"
        @buscarInput="buscarInput"
        @ordenacionCambiada="manejarOrdenacionCambiada"
        @filtrarByClinica="filtrarPorClinica"
        :show-search="false"
        :tipoMovimiento="2"
    >
      <template v-slot:cell(pacienteOrigen)="{item}">
        {{ item.origen.nombrePaciente }}
      </template>
      <template v-slot:cell(pacienteDestino)="{item}">
        {{ item.destino.nombrePaciente }}
      </template>
      <template v-slot:cell(folio)="{item}">
        {{ item.origen.idMovimiento }}
      </template>
      <template v-slot:cell(area)="{item}">
        {{ item.origen.nombreArea }}
      </template>
      <template v-slot:cell(clinica)="{item}">
        {{ item.origen.nombreClinica }}
      </template>
      <template v-slot:cell(empleado)="{item}">
        {{ item.origen.nombreEmpleado }}
      </template>
      <template v-slot:cell(tipoMovimiento)="{item}">
        {{ item.origen.nombreTipoMovimiento }}
      </template>
      <template v-slot:cell(diasSolucion)="{item}">
        <b-badge :variant="obtenerDiasParaResolver(item.origen) > 0 ? 'info':'warning'">
          {{ obtenerDiasParaResolver(item.origen) }}
        </b-badge>
      </template>
      <template v-slot:cell(folioPolizaContableErp)="{item}">
        {{ movimientoService.formatters.string.validarObjetoVacio(item.origen.folioPolizaContableErp) }}
      </template>
      <template v-slot:cell(monto)="{item}">
        {{ item.origen.monto | moneda }}
      </template>

      <template v-slot:cell(saldoTotal)="{item}">
        {{ item.origen.saldoTotal | moneda }}
      </template>

      <template v-slot:cell(pdf)="row">
        <MostrarComprobanteTraspaso v-if="row.item.origen.fechaSolucion != null"
                                    :id-movimiento="row.item.destino.idMovimiento"/>
        <div v-else class="text-info">No se ha completado el proceso</div>
      </template>
      <template
          v-slot:cell(aceptarMovimiento)="{item}"
          v-if="$localStorageService.can('TR_ch_estatus_aceptado')"
      >

        <b-button
            v-if="item.origen.aFavor === false && item.origen.saldoTotal >= item.origen.monto"
            :disabled="itemEnEstatusFinal(item)"
            :variant="itemEnEstatusFinal(item) ? 'secondary': 'success'"
            size="sm"
            v-on:click="cambiarTraspasoEstatusAceptado(item)"
        >
          <font-awesome-icon
              icon="check"
          />
        </b-button>
        <div class="text-info" v-else>Saldo insuficiente</div>

      </template>
      <template v-slot:cell(rechazarMovimiento)="{item}" v-if="$localStorageService.can('TR_ch_estatus_rechazado')">
        <b-button
            :disabled="itemEnEstatusFinal(item)"
            :variant="itemEnEstatusFinal(item) ? 'secondary': 'danger'"
            size="sm"
            v-on:click="cambiarTraspasoEstatusRechazado(item)"
        >
          <font-awesome-icon
              icon="times"
          />
        </b-button>
      </template>
      <template v-slot:cell(autorizaciones)="{item}">
        <b-button
            v-b-modal="'autorizar-'+item.origen.idMovimiento"
            size="sm"
            :disabled="itemEnEstatusFinal(item)"
            :variant="itemEnEstatusFinal(item) ? 'secondary': usuarioAutorizaMovimiento(item.origen.autorizaciones)? 'info':'secondary'"
        >
          <font-awesome-icon
              :icon="autorizacionesCompletas(item.origen.autorizaciones) ? 'check':'eye'"
          />
        </b-button>
        <b-modal
            ok-title="Aceptar"
            cancel-title="Cerrar"
            size="lg"
            :id="'autorizar-'+item.origen.idMovimiento" title="Autorización del movimiento">
          <p class="my-4">
            <AutorizarTraspaso :traspaso="item"></AutorizarTraspaso>
          </p>
        </b-modal>
      </template>
      <template v-slot:cell(detalle)="row">
        <b-button
            v-b-modal="'detalle-'+row.item.origen.idMovimiento"
            size="sm"
            variant="info"
        >
          <font-awesome-icon
              icon="eye"
          />
        </b-button>
        <b-modal
            ok-title="Aceptar"
            cancel-title="Cerrar"
            size="xl" :id="'detalle-'+row.item.origen.idMovimiento" title="Detalle del movimiento">
          <p class="my-4">
            <DetalleTraspaso :fields="movimientoService.fieldsMovimientoDetalle" :traspaso="row.item"/>
          </p>
        </b-modal>
      </template>
      <template v-slot:cell(archivos)="row">
        <b-button v-b-modal="'archivos-'+row.item.origen.idMovimiento" size="sm">
          <font-awesome-icon icon="file"/>
        </b-button>
        <b-modal
            ok-title="Aceptar"
            cancel-title="Cerrar"
            size="lg"
            :id="'archivos-'+row.item.origen.idMovimiento" title="Archivos del movimiento">
          <p class="my-4">
            <ListarArchivos :show-delete="false" :archivos="row.item.origen.archivos"/>
          </p>
        </b-modal>
      </template>
    </TablaEsteroides>
  </b-container>
</template>

<script>
import TablaEsteroides from "@/components/tablaConEsteroides/TablaEsteroides";
import {MovimientoService} from "../../../apiServices/movimiento/MovimientoService";
import DetalleTraspaso from "./DetalleTraspaso";
import AutorizarTraspaso from "./AutorizarTraspaso";
import ListarArchivos from "../../../components/archivos/ListarArchivos";
import MostrarComprobanteTraspaso from "./MostrarComprobanteTraspaso";

export default {
  name: "ListaTraspasosPorEstatus",

  components: {MostrarComprobanteTraspaso, ListarArchivos, AutorizarTraspaso, DetalleTraspaso, TablaEsteroides},
  props: {
    estatus: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      movimientoService: new MovimientoService(),
      diasMaximoMes: null,
      filtro: {
        fechaInicio: null,
        fechaFin: null
      },
      paginaActualPadre: 1,
      textInput: '',
      sortBy : 'idMovimiento',
      sortDirection: 'ASC',
      listMovimientos: [],
      listClinicas: [],
      idsClinicas: [],
    }
  },
  watch: {
    paginaActualPadre() {
      this.listarTraspasos();
    }
  },
  methods: {
    buscarInput(valor) {
      this.textInput = valor;  // Actualizamos textInput con el valor recibido
      this.listarTraspasos();
    },
    manejarOrdenacionCambiada(evento) {
      // Recibir la información de ordenación del componente hijo
      const { sortBy, sortDesc } = evento;
      this.sortBy = sortBy;
      this.sortDirection = sortDesc ? 'DESC' : 'ASC';
      this.listarTraspasos();
    },
    filtrarPorClinica(evento) {
      this.idsClinicas = evento.idsClinica;
      this.listarTraspasos();
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
    },
    async listarTraspasos() {
      this.listMovimientos = await this.movimientoService.listarTraspasosFecha(
          {
            estatusMovimiento: this.estatus,
            fechaInicioZoned: this.filtro.fechaInicio,
            fechaFin: this.filtro.fechaFin,
            pagina: this.paginaActualPadre,
            buscar: this.textInput,
            sortBy: this.sortBy,
            sortDirection: this.sortDirection,
            idsClinica: this.idsClinicas,
          });
      //let listaClinicas = await this.movimientoService.listarTraspasosClinicas({estatusMovimiento: this.estatus, fechaInicioZoned: this.filtro.fechaInicio, fechaFin: this.filtro.fechaFin});
      //this.listClinicas = listaClinicas.map(e => {
      //  if (this.idsClinicas.length > 0 && this.idsClinicas.includes(e.idClinica)) {
      //    return { ...e, selected: true };
      //  }
      //  return { ...e, selected: false };
      //});

    },
    cambiarTraspasoEstatusAceptado(item) {
      this.$swal.fire({
        title: "¿Desea Aceptar el traspaso?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (confirm) => {
          if (confirm) this.movimientoService.cambiarTraspasoEstatusAceptado(item)
              .then(() => {
                this.listarTraspasos();
              })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    cambiarTraspasoEstatusRechazado(item) {
      this.$swal.fire({
        title: "¿Desea rechazar el traspaso?",
        icon: "warning ",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (confirm) => {
          if (confirm) this.movimientoService.cambiarTraspasoEstatusRechazado(item)
              .then(() => {
                this.listarTraspasos();
              })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    itemEnEstatusFinal(item) {
      return item.origen.idEstatusMovimiento === 4 || item.origen.idEstatusMovimiento === 5;
    },
    obtenerDiasParaResolver(item) {
      const dias = item.diasSolucion;
      const d1 = new Date(item.fechaAlta)
      const d2 = new Date(d1)
      d2.setDate(d2.getDate() + dias)
      const d3 = new Date();
      return this.movimientoService.formatters.date.diasDiferencia(d3, d2);
    },
    usuarioAutorizaMovimiento(autorizaciones) {
      return !!autorizaciones.find(autorizacion => autorizacion.idEmpleado === this.$localStorageService.getIdEmpleado())
    },
    autorizacionesCompletas(autorizaciones) {
      return !autorizaciones.find(autorizacion => autorizacion.autorizado === false)
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    Date.prototype.addDays = function(dias) {
      var fecha = new Date(this.valueOf());
      fecha.setDate(fecha.getDate() + dias);
      return fecha;
    }

    /*this.movimientoService.listarTraspasos({estatusMovimiento: this.estatus});
    this.$root.$on('reload-traspasos', async (estatus) => {
      if (estatus === this.estatus || estatus === 'force') {
        this.movimientoService.listarTraspasos({estatusMovimiento: this.estatus});
      }
    })*/
  },
  computed: {
    isLoading() {
      return this.movimientoService.loading;
    }
  }
}
</script>
